module.exports = __webpack_public_path__ + "img/bg_las-vegas-market_las-vegas.b028acf9.jpg";